import React from 'react';
import {connect} from "react-redux";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import AuthService from './../../../../../services/AuthService';
import {TextValidator, ValidatorForm} from 'react-material-ui-form-validator';
import CustomDatePicker from '../../../../shared/utils/CustomDatePicker';
import {setEntretienHeader,} from "../../../../../actions/entreprise/actions_entreprise_entretien";
import moment from '../../../../shared/utils/moment_fr';
import Alert from "../../../../shared/utils/Alert";

class Page1 extends React.Component {

    constructor(props) {
        super(props);
        this.Auth = new AuthService();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event, value) {
        let ent = this.props.entretienHeader;
        let obj = {};
        const name = event.target.name;
        obj[name] = value;
        this.props.dispatch(setEntretienHeader({...ent, ...obj}));
    }

    handleSubmit() {
        const entretienHeader = this.props.entretienHeader;
        this.Auth.fetch('/societe/entretien/' + entretienHeader.id, {
            method: 'PUT',
            data: entretienHeader
        }).then(x => alert('Enregistrement avec succès.'));
    }


    render() {
        const ent = this.props.entretienHeader;
        if (ent.num_entretien) {
            return (
                <div className='row justify-content-md-center'>
                    <div className='col col-sm-10'>
                        <Alert text='Veuillez renseigner les données du salarié'/>
                        <ValidatorForm
                            ref="form"
                            onSubmit={this.handleSubmit}
                        >
                            <div className={'row justify-content-between'}>
                                <TextValidator
                                    className={'col-md-5'}
                                    value={ent.num_entretien}
                                    onChange={this.handleChange}
                                    fullWidth={true}
                                    name='num_entretien'
                                    type="number"
                                    validators={['required', 'trim', 'isNumber', 'minNumber:1']}
                                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire', 'Numéro seulement', 'valeur minimale = 1']}
                                    floatingLabelText="Numéro de l'entretien"
                                />
                                <CustomDatePicker
                                    className={'col-md-5'}
                                    floatingLabelText="Date du dernier entretien"
                                    stringValue={ent.date_dernier}
                                    onChange={(x, y) => this.handleChange({target: {name: 'date_dernier'}}, moment(y).format("YYYY-MM-DD"))}
                                />
                                <SelectField
                                    value={ent.id_type}
                                    className={'col-md-5'}
                                    floatingLabelText="Type de l'entretien"
                                    onChange={(x, y, z) => this.handleChange({target: {name: 'id_type'}}, z)}
                                    maxHeight={400}
                                >
                                    {this.props.params_types_entretien.map(x => <MenuItem key={x.id} value={x.id}
                                                                                          primaryText={x.type}/>)}
                                </SelectField>

                                <SelectField
                                    value={ent.id_motif}
                                    className={'col-md-5'}
                                    floatingLabelText="Motif de l'entretien"
                                    onChange={(x, y, z) => this.handleChange({target: {name: 'id_motif'}}, z)}
                                    maxHeight={400}
                                >
                                    {this.props.params_motifs_entretien.map(x => <MenuItem key={x.id} value={x.id}
                                                                                           primaryText={x.motif}/>)}
                                </SelectField>

                                <TextValidator
                                    className={'col-md-5'}
                                    value={ent.hierarchique}
                                    onChange={this.handleChange}
                                    fullWidth={true}
                                    name='hierarchique'
                                    type="text"
                                    validators={['required', 'trim', 'isString']}
                                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire', 'Ce champs est obligatoire']}
                                    floatingLabelText="Hiérarchique"
                                />

                                <TextValidator
                                    className={'col-md-5'}
                                    value={ent.fonction_hierarchique}
                                    onChange={this.handleChange}
                                    fullWidth={true}
                                    name='fonction_hierarchique'
                                    type="text"
                                    validators={['required', 'trim', 'isString']}
                                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire', 'Ce champs est obligatoire']}
                                    floatingLabelText="Fonction du hiérarchique"
                                />

                                <TextValidator
                                    className={'col-md-5'}
                                    value={ent.entretenant}
                                    onChange={this.handleChange}
                                    fullWidth={true}
                                    name='entretenant'
                                    type="text"
                                    validators={['required', 'trim', 'isString']}
                                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire', 'Ce champs est obligatoire']}
                                    floatingLabelText="Personne en charge de l'entretien"
                                />

                                <TextValidator
                                    className={'col-md-5'}
                                    value={ent.motif_first_entretien}
                                    onChange={this.handleChange}
                                    fullWidth={true}
                                    disabled={ent.num_entretien !== "1"}
                                    name='motif_first_entretien'
                                    type="text"
                                    multiLine={true}
                                    floatingLabelText="Si aucun entretien avant aujourd'hui, définir le motif "
                                />
                            </div>
                            <RaisedButton
                                style={{marginTop: 25}}
                                secondary={true}
                                label={'Enregistrer'}
                                type={'submit'}
                            />
                        </ValidatorForm>
                    </div>
                </div>
            );
        } else {
            return null;
        }

    }
}

function mapStateToProps(store) {
    return {
        params_types_entretien: store.params.types_entretien,
        params_motifs_entretien: store.params.motifs_entretien,
        entretienHeader: store.entretien.header
    }
}

export default connect(mapStateToProps)(Page1);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/Page1.js